import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
const AdminToastContext = createContext(null);
let nextId = 1;
export function AdminToastProvider({ children }) {
    const [items, setItems] = useState([]);
    const show = useCallback((message, kind = 'success') => {
        const id = nextId;
        nextId += 1;
        setItems((prev) => [...prev, { id, message, kind }]);
        window.setTimeout(() => {
            setItems((prev) => prev.filter((item) => item.id !== id));
        }, 4000);
    }, []);
    const value = useMemo(() => ({ show }), [show]);
    return (_jsxs(AdminToastContext.Provider, { value: value, children: [children, _jsx("div", { className: "admin-toasts", "aria-live": "polite", children: items.map((item) => (_jsx("div", { className: `admin-toast admin-toast--${item.kind}`, role: "status", children: item.message }, item.id))) })] }));
}
export function useAdminToast() {
    const ctx = useContext(AdminToastContext);
    if (!ctx)
        throw new Error('useAdminToast outside AdminToastProvider');
    return ctx;
}
